export const svgToBlob = (svgContainerRef) => {
    if (!svgContainerRef.current) {
        return;
    }
    const svgSource = svgContainerRef.current.innerHTML;
    return new Blob([svgSource], { type: 'image/svg+xml;charset=utf-8' });
};
